'use strict';

function pmtNotificationArchive(
	$q,
	$filter,
	pmtNotificationService,
	$i18next,
	pmtPageTitleService
) {
	pmtPageTitleService.setPage($i18next.t('general.alerts'));
	let $ctrl = this;
	$ctrl.notifications = null;
	$ctrl.notificationsByDate = {};
	$ctrl.noNewAlerts = $i18next.t('general.worker_log.no_new_alerts', {
		newAlertsTag: `<strong>${$i18next.t('general.worker_log.new_alerts')}</strong>`,
		sevenDaysTag: `<strong>${$i18next.t('general.worker_log.seven_days')}</strong>`
	});

	$ctrl.isToday = function (date) {
		return new Date(date).toDateString() === new Date().toDateString();
	};

	$q.all({
		dismiss: pmtNotificationService.dismissAllNotifications(),
		notifications: pmtNotificationService.getNotifications()
	})
		.then(function (results) {
			$ctrl.notifications = results.notifications;
			$ctrl.notificationsByDate = $ctrl.notifications.reduce(function (map, obj) {
				let date = $filter('date')(obj.createdAt, 'yyyy-MM-dd');
				map[date] = map[date] || [];
				map[date].push(obj);
				return map;
			}, {});
		})
		.catch(function (error) {
			console.log('error', error);
		});
}

pmtNotificationArchive.$inject = [
	'$q',
	'$filter',
	'pmtNotificationService',
	'$i18next',
	'pmtPageTitleService'
];

angular
	.module('PinMeTo.notifications')

	.component('pmtNotificationArchive', {
		templateUrl: 'pmtShared/notifications/pmtNotificationArchive.html',
		controller: pmtNotificationArchive
	});
